import dayjs from 'dayjs';
import { CLAIM_STATUS } from '../../../../resources/status';

// ค้นตามวันที่ต้องเลือกสถานะเสมอ ช่วงวันที่กว้างไม่เกิน 180 วัน ยกเว้นจัดส่งเรียบร้อยไม่เกิน 31 วัน
// ตรงกับที่ API /claims/by-date ตรวจ ค้นด้วยข้อความ (search) ไม่ใช้สถานะและช่วงวันที่
export const claimDateMaxDays = (claimStatus) => (claimStatus === 'TRANSPORTED' ? 31 : 180);

const toDay = (value) => {
  if (dayjs.isDayjs(value)) return value;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [day, month, year] = value.split('/');
    return dayjs(`${year}-${month}-${day}`);
  }
  return dayjs(value);
};
const hasSearchText = (values) => !!String(values?.search || '').trim();
const selectedDayCount = (range) => {
  if (!range?.[0] || !range?.[1]) return null;
  const days = toDay(range[1]).startOf('day').diff(toDay(range[0]).startOf('day'), 'day') + 1;
  return Number.isFinite(days) && days > 0 ? days : null;
};

export const FORM_SEARCH = ({ onEnter, selectedRange }) => {
  const selectedDays = selectedDayCount(selectedRange);
  return [
    {
      name: 'search',
      label: 'ค้นหารายการ (กรอกข้อมูลแล้วกด Enter เพื่อค้นหา)',
      type: 'INPUT',
      placeholder: '',
      span: 9,
      helper:
        'Tips : สามารถค้นหาด้วย รหัสเคลม , รหัสรับประกัน, เบอร์ , รหัสลูกค้า , ชื่อลูกค้า, เลขพัสดุ',
      onEnter,
    },
    {
      // กรองที่ server ไม่ใช่ที่ browser จึงต้องกดค้นหาก่อนถึงเห็นผล
      // span รวมทั้งแถวต้องเป็น 24 พอดี (9 + 6 + 9) ไม่งั้นช่องใดช่องหนึ่งจะตกไปแถวล่าง
      name: 'claimStatus',
      label: 'สถานะ',
      type: 'DROPDOWN',
      placeholder: 'เลือกสถานะ',
      span: 6,
      rules: {
        validate: (value, values) => hasSearchText(values) || !!value || 'กรุณาเลือกสถานะ',
      },
      properties: {
        options: CLAIM_STATUS.map(({ key, label }) => ({ value: key, label })),
      },
    },
    {
      name: 'startDate',
      label: `ค้นหาข้อมูลรายการเคลมสินค้าโดยอิงวันที่${
        selectedDays ? ` (เลือก ${selectedDays} วัน)` : ''
      }`,
      type: 'DATE_RANGE',
      placeholder: '',
      span: 9,
      rules: {
        required: true,
        validate: (range, values) => {
          if (hasSearchText(values) || !range?.[0] || !range?.[1]) return true;
          const maxDays = claimDateMaxDays(values?.claimStatus);
          const days = toDay(range[1]).diff(toDay(range[0]), 'day');
          return days <= maxDays || `ช่วงวันที่ต้องไม่เกิน ${maxDays} วัน`;
        },
      },
    },
  ];
};

export const FORM_MESSAGE = () => {
  return [
    {
      name: 'message',
      label: 'ข้อความ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      span: 24,
      rules: {
        required: true,
        maxLength: 500,
      },
    },
  ];
};

export const FORM_PROCESS_STATUS = ({ processStatusList = [] }) => {
  const span = 24;
  return [
    {
      name: 'processStatus',
      type: 'DROPDOWN',
      span,
      properties: {
        options: processStatusList.map((status) => ({
          label: status.label,
          value: status.value,
        })),
        defaultValue:
          processStatusList.find((status) => status.label === 'processStatusName')?.value || '',
      },
    },
  ];
};

export const FORM_REMARK = (defaultValues) => {
  return [
    {
      name: 'remark',
      label: 'ข้อความ (ระบุได้ไม่เกิน 250 ตัวอักษร)',
      type: 'INPUT_AREA',
      defaultValue: defaultValues?.remark,
      placeholder: '',
      span: 24,
      rules: {
        required: true,
        maxLength: 250,
      },
    },
  ];
};

export const FORM_TRACKING_NUMBER = ({ shippingOptions }) => {
  const span = 24;
  return [
    {
      name: 'shippingId',
      label: 'ขนส่ง',
      type: 'DROPDOWN',
      placeholder: '',
      properties: {
        options: shippingOptions || [],
      },
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'trackingNumber',
      label: 'เลขพัสดุ',
      type: 'INPUT',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'shippingDate',
      label: 'วันที่จัดส่ง',
      type: 'DATE_PICKER',
      span,
      defaultValue: dayjs(),
      disabled: true,
    },
    {
      name: 'claimId',
      type: 'HIDDEN',
    },
    {
      name: 'claimCode',
      type: 'HIDDEN',
    },
  ];
};

export const useDefault = (initialValues = {}) => {
  const defaultValues = {
    fullName: initialValues.fullName || '',
  };
  return {
    defaultValues,
  };
};

export const searchDefaultValues = {
  startDate: [dayjs().subtract(7, 'day'), dayjs()],
  // เปิดหน้ามาเห็นเฉพาะที่ยังไม่ได้ตรวจ ซึ่งเป็นงานที่ต้องทำจริง
  // กรองที่ server ตั้งแต่ request แรก payload จึงเล็กลงด้วย
  // ค่านี้ถูกใช้ทั้งตอน useForm, ตอน watch() ส่งเข้า API และตอน reset ปุ่มล้าง
  claimStatus: 'WAIT',
};
